import styled, { css } from 'styled-components';

export const Container = styled.div<{ $saving?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: 80vh;

  ${({ $saving }) =>
    $saving &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `};
`;

export const Interactions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  padding: ${({ theme }) => `0 ${theme.spacing(4)} ${theme.spacing(4)}`};
`;
